import React, { useEffect, useState } from "react";
import { toast } from "react-toastify";

import BedAddition from "./BedAddition";
import BedList from "./BedList";
import { getBedTypes } from "../api/bedMasterApi";

/**
 * Bed Management — add form on top, list below, same as the User Management and
 * Doctor Management screens.
 *
 * Departments and bed types are fetched once here and handed to both halves:
 * the add form needs them for its pickers and the list needs them for the edit
 * modal's, so owning them in each component meant loading both lists twice on
 * every page open. The screen now opens on three calls — departments, bed
 * types, beds.
 *
 * The refresh counter is held here rather than reusing App.js's shared
 * `refreshList` (which only ever flips "" -> true, so it signals the first save
 * and no later ones); a counter reloads the grid after every save.
 */
function BedManagement() {
  const [refreshList, setRefreshList] = useState(0);
  const [bedTypes, setBedTypes] = useState([]);

  useEffect(() => {
    getBedTypes()
      .then((list) => setBedTypes(list.filter((bt) => bt?.is_active !== false)))
      .catch((err) => {
        console.error("getBedTypes:", err);
        toast.error("Could not load bed types");
      });
  }, []);

  return (
    <div>
      <BedAddition
        bedTypes={bedTypes}
        updateList={() => setRefreshList((n) => n + 1)}
      />
      <BedList
        bedTypes={bedTypes}
        refreshList={refreshList}
      />
    </div>
  );
}

export default BedManagement;
